<template>
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      viewBox="0 0 180 49.133" enable-background="new 0 0 180 49.133" xml:space="preserve">
<g>
    <path d="M89.787,48.214c-2.239-4.373-4.513-9.491-6.816-15.354
        c-2.305-5.859-4.49-12.246-6.552-19.157h10.366c0.439,1.705,0.956,3.554,1.549,5.544c0.593,1.99,1.207,4.002,1.847,6.037
        c0.636,2.033,1.272,4.013,1.909,5.938c0.639,1.925,1.265,3.674,1.879,5.249c0.57-1.575,1.186-3.324,1.844-5.249
        c0.659-1.925,1.307-3.904,1.942-5.938c0.637-2.035,1.252-4.046,1.845-6.037c0.592-1.99,1.108-3.839,1.548-5.544h10.11
        c-2.063,6.911-4.246,13.297-6.548,19.157c-2.303,5.862-4.573,10.98-6.811,15.354H89.787z"/>
    <path d="M112.24,31.222c0-3.061,0.47-5.741,1.41-8.038
        c0.94-2.297,2.177-4.21,3.707-5.74c1.532-1.531,3.291-2.691,5.283-3.479c1.988-0.787,4.033-1.18,6.134-1.18
        c4.897,0,8.768,1.499,11.612,4.494c2.843,2.996,4.265,7.403,4.265,13.221c0,0.568-0.023,1.192-0.066,1.87
        c-0.044,0.677-0.087,1.278-0.13,1.803h-22.177c0.219,2.014,1.158,3.609,2.821,4.789c1.662,1.183,3.893,1.772,6.692,1.772
        c1.793,0,3.553-0.163,5.281-0.492c1.728-0.328,3.139-0.731,4.232-1.213l1.313,7.938c-0.525,0.264-1.227,0.525-2.101,0.787
        c-0.875,0.264-1.848,0.493-2.918,0.689c-1.074,0.197-2.222,0.36-3.446,0.492c-1.224,0.132-2.45,0.196-3.674,0.196
        c-3.105,0-5.806-0.459-8.103-1.378c-2.296-0.918-4.199-2.175-5.708-3.772c-1.509-1.596-2.624-3.486-3.346-5.674
        S112.24,33.759,112.24,31.222 M135.203,27.483c-0.044-0.831-0.187-1.641-0.426-2.429c-0.241-0.787-0.613-1.486-1.115-2.098
        c-0.503-0.613-1.139-1.116-1.902-1.509c-0.767-0.395-1.718-0.592-2.855-0.592c-1.093,0-2.033,0.188-2.82,0.559
        c-0.787,0.372-1.442,0.864-1.969,1.475c-0.524,0.614-0.93,1.324-1.214,2.133c-0.285,0.81-0.491,1.63-0.623,2.461H135.203z"/>
    <path d="M150.557,14.885c1.661-0.48,3.805-0.929,6.429-1.345
        c2.625-0.415,5.382-0.623,8.267-0.623c2.931,0,5.369,0.383,7.316,1.149c1.945,0.764,3.486,1.847,4.625,3.247
        c1.137,1.4,1.945,3.061,2.428,4.986c0.48,1.925,0.722,4.067,0.722,6.43v19.485h-9.775V29.909c0-3.147-0.417-5.378-1.247-6.691
        c-0.831-1.311-2.385-1.969-4.658-1.969c-0.7,0-1.443,0.033-2.23,0.1c-0.787,0.065-1.488,0.141-2.1,0.228v26.638h-9.775V14.885z"/>
    <path d="M66.111,13.65c2.239,4.373,4.513,9.491,6.816,15.353
        c2.305,5.86,4.49,12.246,6.552,19.157H69.114c-0.44-1.705-0.956-3.554-1.55-5.544c-0.593-1.99-1.207-4.002-1.846-6.036
        c-0.636-2.034-1.272-4.013-1.91-5.938c-0.638-1.925-1.264-3.674-1.879-5.249c-0.57,1.575-1.185,3.324-1.843,5.249
        c-0.659,1.925-1.307,3.903-1.943,5.938c-0.636,2.034-1.252,4.046-1.844,6.036c-0.592,1.99-1.109,3.839-1.548,5.544h-10.11
        c2.063-6.911,4.245-13.297,6.548-19.157c2.302-5.862,4.572-10.979,6.81-15.353H66.111z"/>
    <path d="M9.719,0c0,0-6.034,2.506-1.974,7.364c4.06,4.859,7.493,7.487,14.75,11.847
        c7.258,4.36,14.12,9.911,16.612,15.763c2.491,5.851-0.312,9.164-1.757,10.838c-1.444,1.675-2.568,2.434-2.568,2.434
        s0.842-1.424-2.182-5.003c-3.025-3.579-3.784-5.519-17.804-13.313c-5.933-3.299-12.663-9.344-14.18-13.402
        c-1.481-3.964,0.002-8.01,1.368-10.531C3.349,3.477,7.468,0.397,9.719,0"/>
    <path d="M35.501,6.355c0-2.759-2.236-4.995-4.995-4.995
        c-2.759,0-4.995,2.236-4.995,4.995c0,2.759,2.236,4.995,4.995,4.995C33.265,11.35,35.501,9.114,35.501,6.355"/>
    <path d="M11.985,43.046c0-2.814-2.281-5.095-5.095-5.095
        c-2.814,0-5.095,2.28-5.095,5.095c0,2.813,2.281,5.095,5.095,5.095C9.705,48.141,11.985,45.86,11.985,43.046"/>
</g>
</svg>

</template>

<script>
export default {
    name: 'LogoSaven',
}
</script>

<style lang="scss" scoped>
</style>